<script>
import {mapState, mapActions} from 'vuex';

export default {
    computed: {
        ...mapState({
            languages: state => state.nav.languages,
            selectedLanguage: state => state.nav.language
        })
    },
    created() {
        this.setLanguages(this.$locale.getValidLanguages());
    },
    methods: {
        ...mapActions({
            updateLanguage: 'nav/updateLanguage',
            setLanguages: 'nav/setLanguages'
        }),
        updateLanguageValue(element) {
            this.$locale.change(element.value);
            this.updateLanguage(element);
        }
    }
}
</script>

<template>
    <div class="select-language">
        <div class="select-language__content">
            <div v-if="languages.length > 1" class="select-language__elements">
                <div v-for="language in languages" :key="language.value" class="select-language__element">
                    <img :class="['select-language__image', language.name === selectedLanguage.name ? 'select-language__image-selected' : null]"
                         :src="'https://s3.eu-central-1.amazonaws.com/twenty-data/marketplace/flags/' + language.value + '.png'"
                         @click="updateLanguageValue(language)">
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/SelectLanguage/SelectLanguage.vue